<template>
  <div>
    <v-toolbar  dense tile shaped :elevation="1">
      <div v-if="editing">
        <v-icon>store</v-icon> {{branch.name}}
      </div>
      <branch-combobox v-else v-model="branch" :roles="['SALES','HYBRID']" return-object solo dense hide-details></branch-combobox>
    </v-toolbar>

    <v-card tile outlined class="mt-0">
      <v-card-title class="pb-0 pt-1 cardTitle">Contacto</v-card-title>
      <v-card-text class="pa-2">
        <bar-contact-form></bar-contact-form>
      </v-card-text>
    </v-card>

    <v-card tile outlined  class="mt-0">
      <v-card-title class="pb-0 pt-1 cardTitle">Pago</v-card-title>
      <v-card-text class="pa-2">
        <v-row>
          <v-col cols="12" sm="8">
            <payment-methods-combobox
                v-model="paymentMethod"
                solo outlined dense single-line hide-details
                :only-enable="false"
            ></payment-methods-combobox>
          </v-col>
          <v-col cols="12" sm="4">
            <v-checkbox class="mt-1" v-model="paymentConfirmed" hide-details label="Pagado"></v-checkbox>
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>

    <v-card tile outlined min-height="240" class="mt-0">
      <v-card-title class="pb-0 pt-1 cardTitle">Entrega</v-card-title>
      <bar-order-mode></bar-order-mode>

      <v-card-text class="d-flex justify-space-between" v-if="isTakeAway">
            <v-checkbox
                class="mt-0"
                v-model="onBar"
                hide-details
                :label="$t('delivery.bar.onBar')"
            ></v-checkbox>
            <v-checkbox
                class="mt-0"
                v-model="immediateDelivery"
                hide-details
                :disabled="!immediateDeliveryEnabled"
                :label="$t('delivery.bar.immediateDelivery')"
            ></v-checkbox>
      </v-card-text>
    </v-card>


    <v-card tile outlined class="mt-0">
      <v-card-title class="pb-0 pt-1 cardTitle">Descuentos</v-card-title>
      <v-card-text class="px-3 mt-0">
        <bar-discount-form></bar-discount-form>
      </v-card-text>
    </v-card>

  </div>

</template>

<script>
import BranchCombobox from "@/modules/delivery/combobox/BranchCombobox/BranchCombobox.vue";
import BarContactForm from "@/modules/delivery/components-core/business/BarContactForm/BarContactForm.vue";
import PaymentMethodsCombobox from "@/modules/payment/components/PaymentMethodCombobox/PaymentMethodCombobox.vue";
import BarDiscountForm from "@/modules/delivery/components-core/business/BarDiscountForm/BarDiscountForm.vue";
import BarOrderMode from "@/modules/delivery/components-core/business/BarOrderMode/BarOrderMode.vue";

export default {
  name: "BarOrderPanel",
  components: {
    BarOrderMode,
    BarDiscountForm,
    PaymentMethodsCombobox,
    BarContactForm,
    BranchCombobox
  },
  computed: {
    editing(){
      return this.$store.getters.editing
    },
    branch: {
      get() {
        return this.$store.getters.branchSelected
      },
      set(val) {
        this.$store.commit('branchSelected', val)
        this.$store.commit('setBranch', val)
        this.$emit("branchChanged")
      }
    },
    paymentMethod: {
      get() {
        return this.$store.getters.orderSystem.order.payment.method
      },
      set(val) {
        this.$store.commit('paymentMethod', val)
      }
    },
    paymentConfirmed: {
      get() {
        return this.$store.getters.orderSystem.order.payment.confirmed
      },
      set(val) {
        this.$store.commit('paymentConfirmed', val)
      }
    },
    onBar: {
      get() {
        return this.$store.getters.orderSystem.order.delivery.onBar
      },
      set(val) {
        this.$store.commit('onBar', val)
      }
    },
    immediateDelivery: {
      get() {
        return this.$store.getters.orderSystem.order.delivery.immediateDelivery
      },
      set(val) {
        this.$store.commit('immediateDelivery', val)
      }
    },
    immediateDeliveryEnabled(){
      return this.$store.getters.orderSystem.isImmediateDeliveryEligible
    },
    isTakeAway(){
      return this.$store.getters.orderSystem.order.isTakeAway
    }
  },
  watch: {
    immediateDeliveryEnabled(enabled) {
      if (!enabled && this.immediateDelivery) {
        this.immediateDelivery = false
      }
    },
    isTakeAway(enabled) {
      if (!enabled && this.immediateDelivery) {
        this.immediateDelivery = false
      }
    }
  }
}
</script>

<style scoped>
.cardTitle{
  font-size: 18px;
}
</style>
